import { GoogleLoginResponseType } from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { openSignInWindow } from "../../utils/open-google-popup";
import { api } from "../api";
import { gaKeys, integrationKeys, organizationsKeys } from "../queryKeys";

const googleLogin = async () => {
  const resp = await api.post<GoogleLoginResponseType>(
    `/v2/integrations/google-login`,
    {}
  );
  return resp.data;
};
export const useGoogleLogin = () => {
  const queryClient = useQueryClient();
  const receiveMessage = (event: MessageEvent) => {
    const { data } = event;
    if (
      [
        "http://localhost:3000",
        "https://app.intelligmes.io",
        "https://app-dev.intelligems.io",
      ].includes(event.origin) &&
      (data.type === "google-login" || data.type === "CLOSED")
    ) {
      void queryClient.invalidateQueries({ queryKey: integrationKeys.all });
      void queryClient.invalidateQueries({ queryKey: gaKeys.all });
      void queryClient.invalidateQueries({ queryKey: organizationsKeys.all });
    }
  };

  return useMutation<GoogleLoginResponseType, Error, { newTab?: boolean }, any>(
    {
      mutationFn: async (data) => googleLogin(),
      onSuccess: (data, payload) => {
        openSignInWindow(data.redirect, receiveMessage);
      },
    }
  );
};
